import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useCallback, useMemo } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { Select } from 'foundations-components/transitional/components/Select';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledDivWithCursorText = styled.div.withConfig({
  displayName: "ReorderActivityButtonsSelect__StyledDivWithCursorText",
  componentId: "g6j2pk-0"
})(["cursor:text;"]);
const ReorderActivityButtonsSelect = ({
  allActivityButtonsOptions,
  index,
  onSelectChange,
  selectedActivityType,
  error,
  focusInteractionIndex
}) => {
  const handleOnSelectChange = useCallback(e => {
    const newSelection = e.target.value;
    onSelectChange(newSelection, index, selectedActivityType);
  }, [index, onSelectChange, selectedActivityType]);
  const selectedActivityTypeWithTranslation = useMemo(() => allActivityButtonsOptions.find(activityTypeButton => activityTypeButton.value === selectedActivityType) || {}, [allActivityButtonsOptions, selectedActivityType]);
  const errorMessage = useMemo(() => {
    if (!error) {
      return undefined;
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reorderActivityButtonsModal.errorMessage",
      "data-selenium-test": "activity-buttons-modal-error",
      options: {
        activityButton: selectedActivityTypeWithTranslation.text
      }
    });
  }, [error, selectedActivityTypeWithTranslation]);
  const label = useMemo(() => {
    return /*#__PURE__*/_jsx(StyledDivWithCursorText, {
      id: `activity-modal-label-${index}`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        options: {
          count: index + 1
        },
        message: "reorderActivityButtonsModal.activitySelectLabel"
      })
    });
  }, [index]);
  const AllActivityButtonsOptionsWrapper = _ref => {
    let {
        children
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      tabIndex: 0,
      children: children
    }));
  };
  const select = useMemo(() => {
    // UISelect automatically renders options that contain a icon property
    // @todo Waiting for transitional components to be updated to use the new select component
    return /*#__PURE__*/_jsx(Select, {
      autoFocus: index === focusInteractionIndex,
      clearable: true,
      "data-selenium-test": `activity-button-select-${index + 1}`,
      "aria-labelledby": `activity-modal-label-${index}`,
      itemComponent: AllActivityButtonsOptionsWrapper,
      options: allActivityButtonsOptions,
      value: selectedActivityType,
      onChange: handleOnSelectChange,
      placeholder: /*#__PURE__*/_jsx(Text, {
        as: "span",
        fontStyle: "italic",
        paddingInlineEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reorderActivityButtonsModal.selectPlaceholder"
        })
      })
    });
  }, [index, focusInteractionIndex, allActivityButtonsOptions, selectedActivityType, handleOnSelectChange]);
  return /*#__PURE__*/_jsx(FormControl, {
    error: error,
    label: label,
    validationMessage: errorMessage,
    children: select
  });
};
export default ReorderActivityButtonsSelect;